'use client';

import { useCookieConsentSync } from '@/hooks/useCookieConsentSync';

const CookieConsentSync = () => {
  useCookieConsentSync();
  return null;
};

export default CookieConsentSync;
